import Body, { BodyProps } from '../Body/Body';

interface TextElementProps {
  title?: string;
  text: Required<BodyProps>['richText'];
}

const TextElementNew: React.FC<TextElementProps> = ({ title, text }) => {
  return (
    <div className="w-full flex flex-col tablet:flex-row gap-24 laptop:px-128">
      {title && (
        <h3 className="font-respira text-respira-sm tablet:text-respira-md flex-1 max-w-920 block">
          {title}
        </h3>
      )}
      <Body className="text-lg tablet:text-xl flex-1" richText={text} />
    </div>
  );
};

export default TextElementNew;
